import { V2_PATHS } from 'utils/constants';

export const COGNOTA_ORIGIN = window.location.origin;

export const COGNOTA_REQUEST_MODAL_URL = `${COGNOTA_ORIGIN}${V2_PATHS.REQUEST_MODAL}`;
